import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import { Link } from "react-router-dom";
import { getLaunchReadiness } from "../utils/launchReadiness";

export default function LaunchReadinessChecklist({
  game,
  draftSettings,
  linkCopiedVersion = 0,
  compact = false,
  onStepFocus,
}) {
  void linkCopiedVersion;
  const { items, doneCount, total, allDone } = getLaunchReadiness(
    game,
    draftSettings,
  );

  const stepByItem = {
    content: "start",
    startPost: "start",
    published: "publish",
    linkCopied: "publish",
  };

  return (
    <section
      className={`app-settings-card app-settings-card--launch${
        compact ? " app-settings-card--launch-compact" : ""
      }`}
    >
      <div className="app-launch-checklist__head">
        <h3 className="app-settings-card__title app-settings-card__title--left">
          Готов к запуску
        </h3>
        <span className="app-launch-checklist__progress">
          {doneCount}/{total}
        </span>
      </div>

      {!compact ? (
        <p className="app-launch-checklist__intro">
          {allDone
            ? "Всё готово — можно отправлять ссылку команде."
            : "Проверьте пункты перед рассылкой ссылки сотрудникам."}
        </p>
      ) : null}

      <ul className="app-launch-checklist__list">
        {items.map((item) => {
          const Icon = item.done
            ? CheckCircleOutlineIcon
            : RadioButtonUncheckedIcon;
          const focusStep = stepByItem[item.id];

          return (
            <li
              key={item.id}
              className={`app-launch-checklist__item${
                item.done ? " app-launch-checklist__item--done" : ""
              }${focusStep && onStepFocus ? " app-launch-checklist__item--clickable" : ""}`}
            >
              <Icon className="app-launch-checklist__icon" fontSize="small" />
              <div className="app-launch-checklist__content">
                {focusStep && onStepFocus ? (
                  <button
                    type="button"
                    className="app-launch-checklist__jump"
                    onClick={() => onStepFocus(focusStep)}
                  >
                    <strong>{item.label}</strong>
                  </button>
                ) : (
                  <strong>{item.label}</strong>
                )}
                {!item.done && item.hint ? <p>{item.hint}</p> : null}
              </div>
            </li>
          );
        })}
      </ul>

      {!compact ? (
        <p className="app-launch-checklist__footer">
          Инструкцию для сотрудников можно отправить вместе со ссылкой:{" "}
          <Link to="/dlya-sotrudnika">Инструкция для сотрудников</Link>
        </p>
      ) : null}
    </section>
  );
}
